import { useState } from "react";
import DialogFormPanel from "../../../../../../../shared/components/panel/DialogFormPanel";
import UpdateButtonTrigger from "../../../../../../../shared/components/button/UpdateButtonTrigger";
import UpdateClientCategoryForm from "./UpdateClientCategoryForm";

const UpdateClientCategoryDialog = ({ category, onSubmitHandler }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<UpdateButtonTrigger />}
      title="clients.detail.tabs.categories.updateForm.title"
      description="clients.detail.tabs.categories.updateForm.description"
      content={
        <UpdateClientCategoryForm
          category={category}
          onSubmitHandler={onSubmit}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default UpdateClientCategoryDialog;
